import { findMissingUserInfo } from '@/api/asset/pool/read';
import { SUCCESS } from '@/lib/common/name-space';
import { ResGetStakeCall, ResGetStakeCallAddIndex, UserStakeInfoWithUnstakeType } from '@/types';
import { useState } from 'react';
import { z as zod } from 'zod';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import Grid from '@mui/material/Unstable_Grid2';
import { Box, Button, FormControl, FormHelperText, InputLabel, OutlinedInput, Typography } from '@mui/material';
import { Tables } from '../pools/table/Tables';
import { ContractStakeInfoTableColumns, DbStakeInfoTableColumns } from '../pools/table/ColumnsData';
import { packBigNumbers } from '@/lib/BigNumbers';

const schema = zod.object({
  contractAddr: zod.string().min(1, { message: '컨트랙트 주소, 필수 입력' }),
  address: zod.string().min(1, { message: '사용자 지갑주소, 필수입력' }),
});

type Values = zod.infer<typeof schema>;
const defaultValues = {
  contractAddr: '',
  address: '',
} satisfies Values;

export default function MissingUserData() {
  const [isFind, setIsFind] = useState(false);
  const [info, setInfo] = useState<{
    title: string;
    userInfo: any;
    stakeInfo: ResGetStakeCallAddIndex[] | [];
  }>({
    title: '',
    userInfo: [],
    stakeInfo: [],
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Values>({ defaultValues, resolver: zodResolver(schema) });

  const onSubmit = async (data: Values) => {
    console.log(data);
    const re = await findMissingUserInfo(data);
    console.log(re);
    if (re.status !== SUCCESS) {
      return;
    }
    setIsFind(true);
    const stakeData: ResGetStakeCallAddIndex[] = re.data.stakeInfo.map((item: ResGetStakeCall, index: number) => ({
      ...item,
      index,
      amountStaked: packBigNumbers(item.amountStaked),
    }));
    const userData: UserStakeInfoWithUnstakeType[] = re.data.userInfo.map(
      (item: UserStakeInfoWithUnstakeType, index: number) => ({
        ...item,
        index,
        tot_stake_amt: packBigNumbers(item.tot_stake_amt),
      }),
    );
    setInfo({ title: re.data.title, userInfo: userData, stakeInfo: stakeData });
  };

  return (
    <>
      <Box mb={5} />

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid xs={12}>
            <Controller
              control={control}
              name="contractAddr"
              render={({ field }) => (
                <FormControl error={Boolean(errors.contractAddr)} fullWidth required>
                  <InputLabel>contractAddr</InputLabel>
                  <OutlinedInput {...field} label="contractAddr" type="text" fullWidth />
                  {errors.contractAddr ? <FormHelperText>{errors.contractAddr.message}</FormHelperText> : null}
                </FormControl>
              )}
            />
          </Grid>

          <Grid xs={12}>
            <Controller
              control={control}
              name="address"
              render={({ field }) => (
                <FormControl error={Boolean(errors.address)} fullWidth required>
                  <InputLabel>address</InputLabel>
                  <OutlinedInput {...field} label="address" type="text" fullWidth />
                  {errors.address ? <FormHelperText>{errors.address.message}</FormHelperText> : null}
                </FormControl>
              )}
            />
          </Grid>

          <Grid xs={12}>
            <Button variant="contained" type="submit" fullWidth>
              조회
            </Button>
          </Grid>
        </Grid>
      </form>

      {isFind && (
        <>
          <Box mb={5} />
          <Typography variant="h3" fontWeight="medium" textAlign="left">
            title: {info?.title}
          </Typography>
          <Box mb={5} />
          <Grid container spacing={3}>
            <Grid md={6} xs={12}>
              <Typography variant="h6" fontWeight="medium" textAlign="left">
                db조회 ( ※ db조회에서 언스테이킹이 있으면 언스테이킹한 시점의 시간)
              </Typography>
              <Tables
                list={info.userInfo} // 해당 그룹의 전체 데이터를 Tables 컴포넌트로 전달
                columns={DbStakeInfoTableColumns} // 열 정의
                isToolbar={false}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Typography variant="h6" fontWeight="medium" textAlign="left">
                컨트랙트 조회
              </Typography>
              <Tables
                list={info.stakeInfo} // 해당 그룹의 전체 데이터를 Tables 컴포넌트로 전달
                columns={ContractStakeInfoTableColumns} // 열 정의
                isToolbar={false}
              />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}
